import OrderDetailsStatus from './OrderDetailsStatus'

export default OrderDetailsStatus
